import { Route, Routes } from 'react-router-dom';
import { CompanyForm } from './components/CompanyForm';
import { CompanyList } from './components/CompanyList';
import { CompanyUsers } from './components/CompanyUsers';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { CompanyGroups } from './components/CompanyGroups';

export function CompanyRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.COMPANY) && (
                <>
                    <Route index element={<CompanyList />} />
                    <Route path="edit/:companyId" element={<CompanyForm />} />
                    <Route path="create" element={<CompanyForm />} />
                    <Route path="users/:id" element={<CompanyUsers />} />
                    <Route path="groups/:id" element={<CompanyGroups />} />
                </>
            )}
        </Routes>
    );
}
